
var jobSearch = {
  load:function(){
    this.events();
  },
  events:function(){
    var self = this;
    var holders = document.getElementsByClassName("jobSearch");
    for(let h of holders){
      var form = h.querySelector("form");
      if(form){
        form.addEventListener("submit",function(e){
          e.preventDefault();
          var categoryInput = e.currentTarget.querySelector("select[name='category']");
          var regionInput = e.currentTarget.querySelector("select[name='region']");
          var region = regionInput.options[regionInput.selectedIndex].value;

          var category = categoryInput.options[categoryInput.selectedIndex].value;
          self.route(category,region);
        });

        form.getElementsByClassName("category")[0].querySelector("span").addEventListener("click",function(e){
          var select = e.currentTarget.parentNode.querySelector("select");
          select.click();

        });

        form.getElementsByClassName("location")[0].querySelector("span").addEventListener("click",function(e){
          e.currentTarget.parentNode.querySelector("select").click();

        });
      }

    }
  },
  route:function(category,region){
    jlLoader.show("Searching Job Listings");
    var url = JLAJAX.homeURL + "category/"+category;
    if(region !== ""){
      url += "/"+region;
    }
    parent.location = url;
  }
};


window.addEventListener("DOMContentLoaded",function(){
  jobSearch.load();
});
